<template>
  <div class="ytbvideo">
    <div class="ytbvideo_title">DeepLink Youtube</div>
    <div class="ytbvideo_cont">
      <div class="ytbvideo_li" v-for="(el, index) in youtubeData" @click="linkhref(el.link)">
        <img class="li_img" :src="el.img" alt="">
        <div class="li_title">{{ el.name }}</div>
        <div class="video_info">
          <img class="img" src="../assets/media/youtube_channels.jpg" alt="">
          <div class="name">
            <div class="title">{{ el.channels }}</div>
            <div class="text">{{ el.watchTime }}</div>
          </div>
          <div class="time">{{ el.time }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import { defineComponent, ref, onMounted ,computed } from "vue";
  import { useI18n } from "vue-i18n";
  import { useStore } from "vuex";
  
  import ytb_img5 from "@/assets/media/ytb_img5.webp"
  import ytb_img4 from "@/assets/media/ytb_img4.webp"
  import ytb_img3 from "@/assets/media/ytb_img3.webp"
  import ytb_img2 from "@/assets/media/ytb_img2.webp"
  import ytb_img1 from "@/assets/media/ytb_img1.webp"
  export default defineComponent({
    name: 'ytbvideo',
    setup() {
      const { t, locale } = useI18n()
      const store = useStore()
      let lan = computed(() => store.state.lan)
      const youtubeData = ref([
        {
          name: '🔥Welcome to DEEPLINK CLOUD GAMING🎮: Enjoy high-end gaming experiences even on low-end laptop/PC🚀',
          link: 'https://www.youtube.com/watch?v=dAdjSXhD_y4',
          channels: 'DeepLink Global',
          watchTime: '1.7万次观看',
          time: '8个月前',
          img: ytb_img5
        },
        {
          name: 'リモートゲームの再定義 - DeepLink プロトコル - Web 3.0 - 低スペックなデバイスで高品質なゲームをプレイ',
          link: 'https://www.youtube.com/watch?v=ag45tJTdeTQ',
          channels: 'DeepLink Global',
          watchTime: '2470次观看',
          time: '1个月前',
          img: ytb_img4
        },
        {
          name: 'START YOUR GAMING JOURNEY TODAY WITH DEEPLINK🔥🔥🔥',
          link: 'https://www.youtube.com/watch?v=S5fb4WausbU',
          channels: 'DeepLink Global',
          watchTime: '56次观看',
          time: '2个月前',
          img: ytb_img3
        },
        {
          name: '🔥SAVE 70% COST🔥CLOUD INTERNET CAFE & ESPORTS HOTEL:🌟DeepBrain Chain_Cloud GPU+DeepLink_Cloud Gaming🎮',
          link: 'https://www.youtube.com/watch?v=BIZDO9j-PAE',
          channels: 'DeepLink Global',
          watchTime: '189次观看',
          time: '7个月前',
          img: ytb_img2
        },
        {
          name: '🔥Play Games at Cloud Internet Cafe in Korea🔥DeepBrain Chain_Cloud GPU+DeepLink_Cloud Gaming⚡',
          link: 'https://www.youtube.com/watch?v=mioE6SsEOLQ',
          channels: 'DeepLink Global',
          watchTime: '167次观看',
          time: '7个月前',
          img: ytb_img1
        }
      ])
      const linkhref = (val) => {
        window.open(val)
      }
      return {
        lan,
        linkhref,
        youtubeData
      };
    }
  })
</script>

<style scoped lang="scss">
.ytbvideo {
  width: 1200px;
  margin: 0 auto 60px;
  box-sizing: border-box;
  .show {
    display: block;
  }
  .hide {
    display: none;
  }
  .ytbvideo_title {
    color: #fff;
    font-size: 26px;
    font-weight: 600;
    line-height: 34px;
    text-align: center;
    margin-bottom: 30px;
    letter-spacing: 0.05em;
  }
  .ytbvideo_cont {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .ytbvideo_li {
      width: 380px;
      display: flex;
      cursor: pointer;
      overflow: hidden;
      margin-right: 30px;
      margin-bottom: 12px;
      flex-direction: column;
      &:nth-child(3n) {
        margin-right: 0;
      }
      .li_img {
        width: 380px;
        height: 210px;
      }
      .li_title {
        color: #fff;
        margin: 12px 0;
        font-size: 16px;
        font-weight: 500;
        line-height: 21px;
        letter-spacing: 0em;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .video_info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .img {
          width: 38px;
          height: 38px;
          overflow: hidden;
          border-radius: 38px;
          display: inline-block;
        }
        .name {
          width: 265px;
          margin: 0 12px;
          .title {
            color: #fff;
            font-size: 14px;
            font-weight: 500;
            line-height: 19px;
            letter-spacing: 0em;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .text {
            font-size: 12px;
            font-weight: 400;
            line-height: 16px;
            overflow: hidden;
            white-space: nowrap;
            letter-spacing: 0em;
            text-overflow: ellipsis;
            color: rgba(255, 255, 255, 0.5);
          }
        }
        .time {
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
          letter-spacing: 0em;
          color: rgba(255, 255, 255, 0.5);
        }
      }
    }
  }
}


@media screen and (max-width: 1200px) {
  .ytbvideo {
    width: 90%;
    .show {
      display: none;
    }
    .hide {
      display: block;
    }
    .ytbvideo_cont {
      .ytbvideo_li {
        width: 100%;
        overflow: hidden;
        margin-right: 0;
        border-radius: 20px;
        margin-bottom: 40px;
        .li_img {
          width: 100%;
          height: 360px;
          object-fit: cover;
        }
        .video_info {
          .img {
            width: 48px;
            height: 48px;
          }
          .name {
            flex: 1;
            width: unset;
          }
        }
      }
      
    }
  }
}
</style>